module.exports = __webpack_public_path__ + "img/symbol_4.4ce8be3c.png";